<template>
  <b-container fluid>
    <b-form @submit="onSubmit">
      <b-row>
        <b-button
          v-bind:disabled="disableSave"
          class="ml-4 my-2"
          size="sm"
          type="submit"
          variant="primary"
          style="margin-right: 20px;"
        >{{ saveButton }}</b-button>
        <b-button
          class="my-2"
          size="sm"
          v-if="allowDelete"
          type="button"
          v-b-modal.deleteDialog
          variant="danger"
        >Smazat</b-button>
      </b-row>
      <hr />
      <b-modal id="deleteDialog" title="SMazat osobu">
        <p class="my-4">
          Skutečne chcete smazat:
          <b>{{input.name}}</b> ???
        </p>
        <div slot="modal-footer" class="w-100">
          <b-button variant="danger" @click="deletePeople" size="sm">Smazat</b-button>
          <b-button
            class="float-right"
            variant="success"
            @click="$bvModal.hide('deleteDialog')"
            size="sm"
          >Zrušit</b-button>
        </div>
      </b-modal>

      <div class="py-2" />
      <b-row>
        <b-col md="1">
          <b-col md="1">
            <div style="height: 30px;"></div>
            <div class="cPhoto p-1">
              <b-img-lazy
                v-if="input.id"
                id="profilePhotoInputPreview"
                class="cImg"
                :src="`/api/v1/people/${input.id}/photo/profile?type=preview`"
              />
            </div>
          </b-col>
        </b-col>
        <b-col md="11">
          <b-row>
            <b-col md="1" class="pl-4">
              <b-form-group label="Titul:" label-for="inputDegree">
                <b-form-input v-model="input.degree" id="inputDegree" type="text" size="sm" />
              </b-form-group>
            </b-col>
            <b-col md="5" class="pr-4">
              <b-form-group label="Jméno a Příjmení:" label-for="inputName">
                <b-form-input v-model="input.name" id="inputName" type="text" size="sm" required />
              </b-form-group>
            </b-col>
            <b-col md="6" class="px-4">
              <b-form-group
                :label="'Datum Narození:' + this.inputDateDescription"
                label-for="inputDateOfBirth"
              >
                <b-form-input
                  v-model="input.dateOfBirth"
                  id="inputDateOfBirth"
                  type="date"
                  size="sm"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" class="px-4">
              <b-form-group label="E-mail:" label-for="inputContactEmail">
                <b-form-input
                  v-model="input.contactEmail"
                  id="inputContactEmail"
                  type="email"
                  size="sm"
                />
              </b-form-group>
            </b-col>
            <b-col md="6" class="px-4">
              <b-form-group label="Telefon:" label-for="inputContactPhone">
                <b-form-input
                  v-model="input.contactPhone"
                  id="inputContactPhone"
                  type="tel"
                  size="sm"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" class="px-4">
              <b-form-group label="Adresa:" label-for="inputAddress">
                <b-form-input v-model="input.address" id="inputAddress" type="text" size="sm" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="px-4">
          <b-form-group label="Jazyk:" label-for="inputLang">
            <b-form-select
              v-model="input.language"
              :options="langOptions"
              multiple
              id="inputLang"
              :select-size="9"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" class="px-4">
          <b-form-group label="Řidičák:" label-for="inputDrivingLicense">
            <b-form-select
              v-model="input.drivingLicense"
              :options="drivingLicenseOptions"
              multiple
              id="inputDrivingLicense"
              :select-size="9"
              size="sm"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="px-4">
          <b-form-group label="Pohlaví:" label-for="inputSex">
            <b-form-select
              v-model="input.sex"
              :options="sexOptions"
              id="inputSex"
              size="sm"
              required
            />
          </b-form-group>
        </b-col>
        <b-col md="6" class="px-4">
          <b-form-group label="Národnost:" label-for="inputNationality">
            <b-form-select
              v-model="input.nationality"
              :options="nationalityOptions"
              id="inputNationality"
              size="sm"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="px-4">
          <b-form-group label="Etnikum:" label-for="inputEthnic">
            <b-form-select
              v-model="input.ethnic"
              :options="ethnicOptions"
              id="inputEthnic"
              size="sm"
              required
            />
          </b-form-group>
        </b-col>
        <b-col md="3" class="px-4">
          <b-form-group label="Velikost oblečení:" label-for="inputDressSize">
            <b-form-select
              v-model="input.sizes.dressSize"
              :options="dressSizeOptions"
              id="inputDressSize"
              size="sm"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="px-4">
          <b-form-group label="Detská velikost:" label-for="inputChildSize">
            <b-form-input
              v-model.number="input.sizes.childSize"
              id="inputChildSize"
              type="number"
              size="sm"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="px-4">
          <b-form-group label="Velikost bot:" label-for="inputShoes">
            <b-form-input
              v-model.number="input.sizes.shoes"
              id="inputShoes"
              type="number"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" class="px-4">
          <b-form-group label="Barva očí:" label-for="inputEyes">
            <b-form-select v-model="input.eyes" :options="eyesOptions" id="inputEyes" size="sm" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="px-4">
          <b-form-group label="Barva vlasů:" label-for="inputHairColor">
            <b-form-select
              v-model="input.hair"
              :options="hairOptions"
              id="inputHairColor"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" class="px-4">
          <b-form-group label="Styl vlasů:" label-for="inputHairStyle">
            <b-form-select
              v-model="input.hairStyle"
              :options="hairStyleOptions"
              id="inputHairStyle"
              size="sm"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="px-4">
          <b-form-group label="Zuby:" label-for="inputTeeths">
            <b-form-select
              v-model="input.teeths"
              :options="teethsOptions"
              id="inputTeeths"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" class="px-4">
          <b-form-group label="Ruce:" label-for="inputHands">
            <b-form-select v-model="input.hands" :options="handsOptions" id="inputHands" size="sm" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="px-4">
          <b-form-group label="Brýle:" label-for="inputGlasses">
            <b-form-select
              v-model="input.glasses"
              :options="glassesOptions"
              id="inputGlasses"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" class="px-4"></b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="px-4">
          <b-form-group label="Tetování:" label-for="inputTatoo">
            <b-form-input v-model="input.tatoo" id="inputTatoo" type="text" size="sm" />
          </b-form-group>
        </b-col>
        <b-col md="6" class="px-4">
          <b-form-group label="Piercing:" label-for="inputPiercing">
            <b-form-input v-model="input.piercing" id="inputPiercing" type="text" size="sm" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3" class="px-4">
          <b-form-group label="Výška:" label-for="inputHeight">
            <b-form-input
              v-model.number="input.sizes.height"
              id="inputHeight"
              type="number"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" class="px-4">
          <b-form-group label="Pas:" label-for="inputWaist">
            <b-form-input
              v-model.number="input.sizes.waist"
              id="inputWaist"
              type="number"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" class="px-4">
          <b-form-group label="Boky:" label-for="inputHips">
            <b-form-input v-model.number="input.sizes.hips" id="inputHips" type="number" size="sm" />
          </b-form-group>
        </b-col>
        <b-col md="3" class="px-4">
          <b-form-group label="Hlava:" label-for="inputHead">
            <b-form-input v-model.number="input.sizes.head" id="inputHead" type="number" size="sm" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3" class="px-4">
          <b-form-group label="Hruď:" label-for="inputBreast">
            <b-form-input
              v-model.number="input.sizes.breast"
              id="inputBreast"
              type="number"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" class="px-4">
          <b-form-group label="Krk:" label-for="inputNeck">
            <b-form-input v-model.number="input.sizes.neck" id="inputNeck" type="number" size="sm" />
          </b-form-group>
        </b-col>
        <b-col md="3" class="px-4">
          <b-form-group label="Nehty stav:" label-for="inputNails">
            <b-form-select v-model="input.nails" :options="nailsOptions" id="inputNails" size="sm" />
          </b-form-group>
        </b-col>
        <b-col md="3" class="px-4">
          <b-form-group label="Nehty délka:" label-for="inputNailsLength">
            <b-form-select
              v-model="input.nailsLength"
              :options="nailsLengthOptions"
              id="inputNailsLength"
              size="sm"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3" class="px-4">
          <b-form-checkbox
            class="big-checkbox"
            id="inputExperience"
            v-model="input.cameraExperience"
            switch
          >Kam.&nbsp;zkušenost</b-form-checkbox>
        </b-col>
        <b-col md="3" class="px-4">
          <b-form-checkbox
            class="big-checkbox"
            id="inputKomparz"
            v-model="input.komparz"
            switch
          >Komparz</b-form-checkbox>
        </b-col>
        <b-col md="3" class="px-4">
          <b-form-checkbox
            class="big-checkbox"
            id="inputUnderwear"
            v-model="input.underwear"
            switch
          >Spodní&nbsp;prádlo</b-form-checkbox>
        </b-col>
        <b-col md="3" class="px-4">
          <b-form-checkbox class="big-checkbox" id="inputNaked" v-model="input.naked" switch>Nahota</b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="px-4">
          <b-form-group label="Kategorie:" label-for="inputCathegory">
            <b-form-select
              v-model="input.cathegory"
              :options="cathegoryOptions"
              multiple
              id="inputCathegory"
              :select-size="10"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" class="px-4">
          <b-form-group label="Poznámka:" label-for="inputDescription">
            <b-form-textarea
              id="inputDescription"
              v-model="input.description"
              rows="8"
              max-rows="8"
              size="sm"
              no-resize
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="px-4"></b-col>
        <b-col md="6" class="px-4">
          <b-form-checkbox class="big-checkbox" id="inputGdpr" v-model="input.gdpr" switch>GDPR</b-form-checkbox>
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-button
          v-bind:disabled="disableSave"
          class="ml-4 my-2 mb-4"
          size="sm"
          type="submit"
          variant="primary"
          style="margin-right: 20px;"
        >{{ saveButton }}</b-button>
      </b-row>
    </b-form>

    <b-modal id="requestGallery" ref="requestGallery" title="Přidat fotky do galerie?">
      <div slot="modal-footer" class="w-100">
        <b-button
          variant="danger"
          @click="$refs['requestGallery'].hide()"
          to="/people"
          size="sm"
        >Uložit a zavřít</b-button>
        <b-button
          :to="`/people-edit/${peopleID}/1`"
          class="float-right"
          variant="success"
          size="sm"
        >Přidat fotky</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
  name: 'PeopleDetail',
  data () {
    return {
      peopleID: null,
      allowDelete: false,
      disableSave: false,
      inputDateDescription: '',
      sexOptions: [],
      langOptions: [],
      ethnicOptions: [],
      nationalityOptions: [],
      drivingLicenseOptions: [],
      hairOptions: [],
      hairStyleOptions: [],
      eyesOptions: [],
      dressSizeOptions: [],
      cathegoryOptions: [],
      handsOptions: [],
      teethsOptions: [],
      nailsOptions: [],
      nailsLengthOptions: [],
      glassesOptions: [],
      saveButton: 'Uložit jako nový záznam',
      input: {
        id: null,
        name: null,
        degree: null,
        sex: null,
        dateOfBirth: null,
        nationality: null,
        ethnic: null,
        language: [],
        description: null,
        komparz: false,
        naked: false,
        underwear: false,
        gdpr: false,
        cameraExperience: false,
        cathegory: [],
        drivingLicense: [],
        address: null,
        contactPhone: null,
        contactEmail: null,
        sizes: {
          heigh: null,
          breast: null,
          waist: null,
          hips: null,
          shoes: null,
          dressSize: null,
          childSize: 0,
          neck: null,
          head: null
        },
        hair: null,
        hairStyle: null,
        eyes: null,
        teeths: null,
        nails: null,
        nailsLength: null,
        tatoo: null,
        piercing: null,
        hands: null,
        glasses: null
      }
    }
  },
  mounted () {
    axios
      .get('/api/v1/const/sex')
      .then(response => {
        this.sexOptions = response.data
      })
    axios
      .get('/api/v1/const/language')
      .then(response => {
        this.langOptions = response.data
      })
    axios
      .get('/api/v1/const/ethnic')
      .then(response => {
        this.ethnicOptions = response.data
      })
    axios
      .get('/api/v1/const/nationality')
      .then(response => {
        this.nationalityOptions = response.data
      })
    axios
      .get('/api/v1/const/drivinglicense')
      .then(response => {
        this.drivingLicenseOptions = response.data
      })
    axios
      .get('/api/v1/const/hair')
      .then(response => {
        this.hairOptions = response.data
      })
    axios
      .get('/api/v1/const/hair-style')
      .then(response => {
        this.hairStyleOptions = response.data
      })
    axios
      .get('/api/v1/const/eyes')
      .then(response => {
        this.eyesOptions = response.data
      })
    axios
      .get('/api/v1/const/dresssize')
      .then(response => {
        this.dressSizeOptions = response.data
      })
    axios
      .get('/api/v1/const/hands')
      .then(response => {
        this.handsOptions = response.data
      })
    axios
      .get('/api/v1/const/teeths')
      .then(response => {
        this.teethsOptions = response.data
      })
    axios
      .get('/api/v1/const/nails')
      .then(response => {
        this.nailsOptions = response.data
      })
    axios
      .get('/api/v1/const/nailsLength')
      .then(response => {
        this.nailsLengthOptions = response.data
      })
    axios
      .get('/api/v1/const/glasses')
      .then(response => {
        this.glassesOptions = response.data
      })
    axios
      .get('/api/v1/const/cathegory')
      .then(response => {
        this.cathegoryOptions = response.data
      })
    if (this.$route.params.id !== undefined) {
      this.saveButton = 'Uložit úpravy v záznamu'
      this.allowDelete = true
      var id = this.$route.params.id
      axios
        .get(`/api/v1/people/${id}`)
        .then(response => {
          this.input = response.data
        })
    }
    // Test if <input type="date" is supported>
    var input = document.createElement('input')
    input.setAttribute('type', 'date')
    input.setAttribute('value', 'test')
    if (input.value === 'test') {
      this.inputDateDescription = ' (YYYY-MM-DD)'
    }
    input.remove()
  },
  computed: {
    nationalityState () {
      return this.input.nationality.length < 4
    }
  },
  methods: {
    deletePeople () {
      axios
        .delete(`/api/v1/people/${this.input.id}`)
        .then(response => {
          this.$bvModal.hide('deleteDialog')
          this.$router.push('/people')
        })
        .catch(response => {
          console.log('delete error', response.data)
        })
    },
    onSubmit (e) {
      e.preventDefault()
      // console.log(this.input)
      console.log(this.input)
      var phoneOrig = this.input.contactPhone // Telefonne cislo pred validaci - on Error sa znova nastavi
      if (this.input.id !== null) {
        this.disableSave = true
        this.input.contactPhone = this.validatePhone(this.input.contactPhone)
        if (this.input.contactPhone === 'error') {
          this.input.contactPhone = phoneOrig
          return
        }
        axios.put(`/api/v1/people/${this.input.id}`, this.input)
          .then(response => {
            this.$bvToast.toast(`Uloženo`, {
              title: 'Uprava osoby',
              variant: 'success',
              autoHideDelay: 1000
            })
            this.disableSave = false
          })
          .catch(err => {
            alert('updateError: ', err)
            this.disableSave = false
          })
      } else {
        this.disableSave = true
        this.input.contactPhone = this.validatePhone(this.input.contactPhone)
        if (this.input.contactPhone === 'error') {
          this.input.contactPhone = phoneOrig
          return
        }
        axios.post('/api/v1/people', this.input)
          .then(response => {
            this.peopleID = response.data.id
            this.$bvToast.toast(`Uloženo`, {
              title: 'Nahrání osoby',
              variant: 'success',
              autoHideDelay: 1000
            })
            this.disableSave = false
          })
          .then(this.$refs['requestGallery'].show())
          .catch(err => {
            alert('saveAsNewError: ', err)
            this.disableSave = false
          })
      }
    },
    validatePhone (phoneNumber) {
      phoneNumber = phoneNumber.replace(/ /g, '')
      if (phoneNumber.length === 0 || phoneNumber.length < 9) {
        this.$bvToast.toast(`Špatný formát telefonniho čísla`, {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 3000
        })
        this.disableSave = false
        return 'error'
      }
      if (phoneNumber.length === 9) {
        phoneNumber = '+420' + phoneNumber
      }
      if (phoneNumber[0] === '0' && phoneNumber[1] === '0') {
        while (phoneNumber.charAt(0) === '0') {
          phoneNumber = phoneNumber.substr(1)
        }
        phoneNumber = '+' + phoneNumber
      }
      if (/^\+420[0-9]{9}$/.test(phoneNumber)) {
        return phoneNumber
      }
      this.$bvToast.toast(`Špatný formát telefonniho čísla`, {
        title: 'Error',
        variant: 'danger',
        autoHideDelay: 3000
      })
      this.disableSave = false
      return 'error'
    }
  }
})
</script>

<style>
.big-checkbox {
  width: 40px;
  height: 40px;
}
.cPhoto {
  display: flex;
  flex: 1;
  height: 190px;
  min-width: 7vw;
  background-image: radial-gradient(
    rgb(220, 220, 220) 30%,
    rgb(255, 255, 255) 75%
  );
}
</style>
